import { makeStyles } from '@material-ui/core/styles';
import { userTheme } from '../config';

const userProfileStyles = makeStyles(theme => ({
  userProfile: {
    '&__card': {
      margin: 15,
      position: 'relative',
      minHeight: 550,
      backgroundColor: theme.palette.black,
      border: '1px solid',
      borderColor: theme.palette.green,
      boxShadow: '0 0 12px rgba(6, 182, 212, 0.2)',
      color: theme.palette.white,
      width: '100%',
      '&--inactive': {
        borderColor: theme.palette.error.main,
      },
      '&__body': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: 50,
      },
      '&__divider': {
        border: '0',
        borderTop: `1px solid ${theme.palette.iconDivider}`,
        margin: '20px auto',
        width: '80%',
      },
      '&__footer': {
        padding: 5,
        '&:hover &__icon': {
          color: theme.palette.green,
        },
        '&:hover &__title': {
          color: theme.palette.green,
        },
        '&__icon': {
          transition: 'color 0.25s',
          '& svg': {
            width: 25,
            height: 25,
          },
          '&--active': {
            color: theme.palette.green,
          },
          '&--inactive': {
            color: theme.palette.error.main,
          },
          '&--padding': {
            padding: '5px',
          },
        },
        '&__title': {
          color: theme.palette.white,
          fontSize: 10,
          transition: 'color 0.25s',
        },
      },
      '&__header': {
        backgroundColor: theme.palette.sideBarBackgroundColor,
        height: '130px',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
      },
      '&__user': {
        color: theme.palette.white,
        fontSize: '1.57em',
        fontWeight: 700,
        margin: 15,
        textAlign: 'center',
        minHeight: 100,
        '&__details': {
          width: '100%',
          padding: '0 15px',
          minHeight: 30,
          fontSize: '12px',
          flexWrap: 'wrap',
          '&__title': {
            flex: 1,
          },
          '&__value': {
            textAlign: 'right',
            flex: 2,
          },
          '&--strong': {
            fontWeight: 700,
          },
        },
        '&__image': {
          borderRadius: '50%',
          height: '124px',
          margin: '0 auto',
          width: '124px',
          zIndex: '20',
          '&__header': {
            height: '100%',
            width: '100%',
          },
        },
        '&--active': {
          textShadow: `0 0 5px ${theme.palette.green}`,
        },
        '&--inactive': {
          textShadow: `0 0 5px ${theme.palette.error.main}`,
        },
      },
      '&--border-radius': {
        borderRadius: '12px',
      },
    },
  },
  userProfileCalc: () => {
    if (theme.palette.type === userTheme.dark) {
      return {
        '&__card': {
          backgroundColor: theme.palette.sideBarBackgroundColor,
          border: '0 none',
          borderRadius: '.2857rem',
          boxShadow: `0 1px 20px 0 ${theme.palette.iconDivider}`,
          '&__user': {
            '&__image': {
              '&__header': {
                '&--display': {
                  display: 'none',
                },
              },
            },
            '&__name': {
              '&__surname': {
                color: theme.palette.white,
                fontSize: '.8125rem',
                fontWeight: '600',
                margin: '15px 0px',
              },
              '&__username': {
                color: theme.palette.white,
                fontSize: '1.14em',
                fontWeight: '300',
                marginTop: '-7px',
                textAlign: 'center',
              },
            },
            '&__info': {
              color: theme.palette.white,
              display: 'block',
              fontWeight: '300',
            },
          },
        },
      };
    }
    return {
      '&__card': {
        border: '0 none',
        borderRadius: '12px',
        boxShadow: `0 6px 10px -4px ${theme.palette.iconColor}`,
        '&__user': {
          '&__image': {
            '&__header': {
              height: '100%',
              width: '100%',
            },
          },
          '&__name': {
            '&__surname': {
              color: theme.palette.primary.main,
              fontSize: '1.57em',
              fontWeight: '700',
              marginBottom: '15px',
            },
            '&__username': {
              color: theme.palette.iconColor,
              fontWeight: '300',
              marginTop: '-7px',
              textAlign: 'center',
            },
          },
          '&__info': {
            color: theme.palette.iconColor,
            display: 'block',
            fontWeight: '300',
          },
        },
      },
    };
  },
}));
export { userProfileStyles };
